import { extend } from 'lodash';
import * as Yup from 'yup';

export const medicalHistoryWeightloss = [
  {
    id: 'vitals',
    type: 'HeightWeight',
    endpoint: 'socialHistory',
    prompt: 'Please enter your height and weight',
    defaults: { LOCAL_121: '', LOCAL_122: '' },
    schema: Yup.object().shape({
      LOCAL_121: Yup.string().required('Required'),
      LOCAL_122: Yup.string().required('Required'),
    }),
    options: [
      { questionId: 'LOCAL_121', placeholder: `Height (e.g. 6'3")` },
      {
        questionId: 'LOCAL_122',
        placeholder: 'Weight (pounds)',
        // inputType: 'number',
      },
    ],
    lowBmiEndpoint:'medication-bottle',
    normalBmiEndpoint:'weightGoal'
  },
  {
    id: 'medication-bottle',
    type: 'MedicationBottlePicture',
  },
  {
    id: 'upload-visit-note',
    type: 'UploadLastVisitNotes',
  },
  {
    id: 'disclaimer-existing-glp1',
    type: 'disclaimer',
    title: 'Disclaimer for existing GLP-1 patients',
    prompt: 'If you are transitioning your GLP-1 care to Paloma Health, please note that your provider may request you to confirm your current weight by stepping on a scale during your visit. This is to ensure safe and appropriate continuation of your treatment.',
  },
  {
    id: 'weightGoal',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'What is your goal weight?',
    defaults: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? { LOCAL_203: '' } : { LOCAL_581: '' },
    description: `Please note that while this information is helpful, medical decisions will be made by the clinicians keeping clinical evidence and patient safety at the forefront.`,
    prefix: 'Goal Weight:',
    inputmode: 'numeric',
    answer: 'Y',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL_203' : 'LOCAL_581',
        placeholder: 'Enter your goal weight in pounds (lbs)',
      },
    ],
  },

  {
    id: 'initial-conditions',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of the following apply to you? ',
    descriptionFemale: 'Please note that we strongly recommend that you use an effective method of contraception during treatment with a GLP-1 medication and for at least 2 months thereafter.',
    options: [
      {
        value: 'End-stage kidney disease (on or about to be on dialysis)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '9' : '9',
        answer: 'End-stage kidney disease (on or about to be on dialysis)',
        disqualifyingText: 'End-stage kidney disease (on or about to be on dialysis)',
        isDisqualifying: true,
      },
      {
        value: 'End-stage liver disease (cirrhosis)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '10' : '10',
        answer: 'End-stage liver disease (cirrhosis)',
        disqualifyingText: 'End-stage liver disease (cirrhosis)',
        isDisqualifying: true,
      },
      {
        value: 'Current or prior eating disorder (anorexia/bulimia)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '462' : '481',
        disqualifyingText: 'Current or prior eating disorder (anorexia/bulimia)',
        isDisqualifying: true,
      },
      {
        value: 'Current suicidal thoughts and/or prior suicidal attempt',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '463' : '482',
        disqualifyingText: 'Current suicidal thoughts and/or prior suicidal attempt',
        isDisqualifying: true,
      },
      {
        value: 'Cancer (active diagnosis or treatment)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '290' : '290',
        disqualifyingText: 'Cancer (active diagnosis or treatment)',
        isDisqualifying: true,
      },
      {
        value: 'History of organ transplant on anti-rejection medication',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '466' : '485',
        disqualifyingText: 'History of organ transplant on anti-rejection medication',
        isDisqualifying: true,
      },
      {
        value: 'Severe gastrointestinal condition (gastroparesis inflammatory bowel disease)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '464' : '483',
        disqualifyingText: 'Severe gastrointestinal condition (gastroparesis inflammatory bowel disease)',
        isDisqualifying: true,
      },
      {
        value: 'Current participation in or subscription to another medical weight loss program and/or currently taking another medication for weight loss',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '465' : '484',
        disqualifyingText: 'Current participation in or subscription to another medical weight loss program and/or currently taking another medication for weight loss',
        // isDisqualifying: true,
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },
  {
    id: 'currentPregnant',
    type: 'single',
    endpoint: 'obgyn',
    prompt: 'Are you currently pregnant?',
    femaleOnly: true,
    options: [
      {
        questionId: 'LOCAL.83',
        answer: 'Currently pregnant',
        display: 'Currently pregnant',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: 'LOCAL.83',
        answer: 'Planning to be pregnant',
        display: 'Plan to be',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: 'LOCAL.83',
        answer: 'Not pregnant',
        display: 'Not pregnant',
      },
    ],
  },
  {
    id: 'breastfeeding',
    type: 'single',
    endpoint: 'obgyn',
    prompt: 'Are you currently breastfeeding or bottle-feeding with breastmilk?',
    femaleOnly: true,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.582' : 'LOCAL.582',
        answer: 'Y',
        display: 'Yes',
        isDisqualifying: true,
        nextQuestion: 'disqualified',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.582' : 'LOCAL.582',
        answer: 'N',
        display: 'No',
      },
    ],
  },
  {
    id: 'bariatric-surgery',
    type: 'input',
    endpoint: 'surgicalHistory',
    prompt: 'Have you had bariatric (weight loss) surgery before? If so, please include the date and type of surgery.',
    defaults: { '43846': '' },
    prefix: 'Past bariatric surgeries -',
    extend: true,
    skip: 'hospital',
    skipText: `I never had bariatric surgery`,
    options: [{ questionId: '43846', placeholder: 'Date and type of surgery' }],
  },
  {
    id: 'hospital',
    type: 'input',
    endpoint: 'surgicalHistory',
    skip: 'medical-conditions',
    // onlyFirstTime: true,
    prompt: 'Please list all other surgeries and hospitalizations, including approximate dates for each',
    defaults: { '80050': '' },
    prefix: 'Past surgeries / hospitalizations -',
    extend: true,
    options: [{ questionId: '80050', placeholder: 'Add them here...' }],
  },

  {
    id: 'medical-conditions',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of these apply to you? ',
    options: [
      {
        value: 'Gallbladder disease',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '469' : '488',
      },
      {
        value: 'Severe hypertension (≥160/100 mmHg)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '8' : '8',
      },
      // {
      //   value: 'Elevated blood pressure (above 160/100 mmHg)',
      //   questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '424' : '465',
      // },
      {
        value: 'Sleep apnea',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '470' : '489',
      },
      {
        value: 'Gout',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '16' : '16',
      },
      {
        value: 'High cholesterol',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '402' : '467',
      },
      {
        value: 'High triglycerides',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '471' : '490',
      },
      {
        value: 'Coronary artery disease',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '291' : '291',
      },
      {
        value: 'recent (last 24 months) heart attack',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '341' : '345',
      },
      {
        value: 'stroke',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '11' : '11',
      },
      {
        value: 'History of congestive heart failure',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '472' : '491',
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },

  {
    id: 'mental-health_neurological-history',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of these apply to you? ',
    options: [
      {
        value: 'Seizure',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '294' : '294',
      },
      {
        value: 'Glaucoma',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '473' : '492',
      },
      {
        value: 'Depression',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '5' : '5',
      },
      {
        value: 'anxiety',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '285' : '285',
      },
      {
        value: 'bipolar disorder',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '474' : '493',
      },
      {
        value: 'other mental health diagnosis',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '475' : '494',
      },
      {
        value: 'Head injury',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '476' : '495',
      },
      {
        value: 'Tumor or infection in your brain or spinal cord',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '477' : '496',
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },

  {
    id: 'endocrine-history',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of these apply to you? ',
    options: [
      {
        value: 'Personal or family history of thyroid cyst, thyroid cancer, medullary thyroid carcinoma, or multiple endocrine neoplasia syndrome type 2',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '479' : '498',
        // isDisqualifying: true,
        // disqualifyingText: 'Personal or family history of thyroid cyst, thyroid cancer, medullary thyroid carcinoma, or multiple endocrine neoplasia syndrome type 2',
      },
      {
        value: 'Low sodium',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '480' : '499',
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },

  {
    id: 'other-health-conditions',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of these apply to you? ',
    options: [
      {
        value: 'Liver disease',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '10' : '10',
      },
      {
        value: 'Kidney disease',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '9' : '9',
      },
      {
        value: 'Elevated resting heart rate or a diagnosis of tachycardia',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '482' : '501',
      },
      {
        value: 'Diagnosed with the human immunodeficiency virus (HIV)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '483' : '502',
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },

  {
    id: 'diabetes',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Do any of the following conditions related to diabetes apply to you? ',
    nextQuestion: 'blood-pressure-measured-recently',
    options: [
      {
        value: 'Type 2 diabetes (not on insulin)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '425' : '471',
        answer: 'Type 2',
        nextQuestion: 'diabetes-type2-glucose',
      },
      {
        value: 'Type 2 diabetes (on insulin)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '433' : '468',
        answer: 'Type 2',
        isDisqualifying: true,
        disqualifyingText: 'Type 2 diabetes on insulin',
        nextQuestion: 'disqualified',
      },
      {
        value: 'Type 1 diabetes',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '433' : '468',
        answer: 'Type 1',
        isDisqualifying: true,
        disqualifyingText: 'Type 1',
        nextQuestion: 'disqualified',
      },
      {
        value: 'Diabetic retinopathy (eye condition related to diabetes)',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '467' : '486',
      },
      {
        value: 'History of or current pancreatitis',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '468' : '487',
      },
      {
        value: 'None of the above',
        isNoneClear: true,
      },
    ],
  },
  {
    id: 'diabetes-type2-glucose',
    type: 'diabetes2GlucoseHbA1c',
    skip: 'blood-pressure-measured-recently',
    endpoint: 'vitals',
    skipText: `I don't know`,
  },
  {
    id: 'blood-pressure-measured-recently',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: 'Have you had your blood pressure measured in the last six months?',
    description: `It's important to provide a recent reading as it can affect what types of medications are safe for you.`,
    options: [
      { questionId: 'ans', answer: 'Yes', display: 'Yes', value: 'Yes', nextQuestion: 'blood-pressure-range' },
      {
        questionId: 'ans',
        answer: 'No',
        display: 'No',
        value: 'No',
        nextQuestion: 'blood-pressure-measured-need',
      },
    ],
  },
  {
    id: 'blood-pressure-measured-need',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: `We'll need a blood pressure reading`,
    description: `Go ahead and complete your health assessment, but your prescription won't be processed until you tell us your blood pressure numbers.`,
    description2:`You can have your blood pressure checked at most pharmacies or use a home blood pressure cuff. If you aren't sure when you last had it taken, call your doctor's office and ask if it was within six months and what the numbers were. After you submit your request we'll send you a message reminding you to tell us your blood pressure.`,
    options: [
      { questionId: 'ans', answer: 'Got it', display: 'Got it', value: 'Got it', nextQuestion: 'heart-rate-range' },      
    ],
  },
  {
    id: 'blood-pressure-range',
    type: 'single',
    endpoint: 'vitals',
    prompt: 'What was your most recent blood pressure reading?',
    femaleOnly: true,
    options: [
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '129/80',
        display: 'Normal (Less than 129/80)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '130/80',
        display: 'Elevated (130-139/80-89)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '140/90',
        display: 'High (140-149/90-99)',
      },
      {
        questionId: 'VITALS_BLOODPRESSURE',
        answer: '150/100',
        display: 'Very High (More than 150/100)',
      },
    ],
  },

  // {
  //   id: 'blood-pressure-range',
  //   type: 'input',
  //   endpoint: 'vitals',
  //   skipText: `I don't know`,
  //   prompt: 'What is your current or average blood pressure range?',
  //   description: 'Enter your blood pressure reading in the format "systolic/diastolic" (e.g., 120/80). Make sure there are no extra spaces or characters',
  //   prefix: '',
  //   answer: 'Y',
  //   options: [
  //     {
  //       questionId: 'VITALS_BLOODPRESSURE',
  //       placeholder: 'Blood pressure in the format "systolic/diastolic" (e.g., 120/80)',
  //     },
  //   ],
  // },

  {
    id: 'heart-rate-range',
    type: 'input',
    endpoint: 'vitals',
    skipText: `I don't know`,
    prompt: 'What is your current or average heart rate range?',
    description: 'Enter your heart rate value in bpm (e.g., 80)',
    prefix: '',
    answer: 'Y',
    inputmode: 'numeric',
    options: [
      {
        questionId: 'VITALS_HEARTRATE',
        placeholder: 'your heart rate value in bpm (e.g., 80)',
        inputmode: 'numeric',
      },
    ],
  },

  {
    id: 'hypomed',
    skip: 'medications',
    type: 'medicationPick',
    endpoint: 'medications',
    title: 'Hypothyroidism Medications',
    prompt: 'Please list your hypothyroidism medication',
    other: { questionId: '367151' },
    isInputOnly: false,
    options: [
      {
        value: 'Unithroid',
        hasDosage: false,
        questionId: 313430,
      },
      {
        value: 'Unithroid 100 mcg tablet',
        hasDosage: true,
        questionId: 248353,
      },
      {
        value: 'Unithroid 112 mcg tablet',
        hasDosage: true,
        questionId: 239279,
      },
      {
        value: 'Unithroid 125 mcg tablet',
        hasDosage: true,
        questionId: 239194,
      },
      {
        value: 'Unithroid 137 mcg tablet',
        hasDosage: true,
        questionId: 348963,
      },
      {
        value: 'Unithroid 150 mcg tablet',
        hasDosage: true,
        questionId: 246691,
      },
      {
        value: 'Unithroid 175 mcg tablet',
        hasDosage: true,
        questionId: 252038,
      },
      {
        value: 'Unithroid 200 mcg tablet',
        hasDosage: true,
        questionId: 233390,
      },
      {
        value: 'Unithroid 25 mcg tablet',
        hasDosage: true,
        questionId: 251346,
      },
      {
        value: 'Unithroid 300 mcg tablet',
        hasDosage: true,
        questionId: 245346,
      },
      {
        value: 'Unithroid 50 mcg tablet',
        hasDosage: true,
        questionId: 244067,
      },
      {
        value: 'Unithroid 75 mcg tablet',
        hasDosage: true,
        questionId: 253346,
      },
      {
        value: 'Unithroid 88 mcg tablet',
        hasDosage: true,
        questionId: 226774,
      },
      {
        value: 'Thyrogen',
        hasDosage: false,
        questionId: 310408,
      },
      {
        value: 'Thyrogen 0.9 mg intramuscular solution',
        hasDosage: true,
        questionId: 396360,
      },
      {
        value: 'liothyronine',
        hasDosage: false,
        questionId: 302000,
      },
      {
        value: 'liothyronine (bulk)',
        hasDosage: true,
        questionId: 349888,
      },
      {
        value: 'liothyronine (bulk) 1 mg/gram powder',
        hasDosage: true,
        questionId: 361005,
      },
      {
        value: 'liothyronine (bulk) 100 % powder',
        hasDosage: true,
        questionId: 227807,
      },
      {
        value: 'liothyronine 10 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 230025,
      },
      {
        value: 'liothyronine 25 mcg tablet',
        hasDosage: true,
        questionId: 230116,
      },
      {
        value: 'liothyronine 5 mcg tablet',
        hasDosage: true,
        questionId: 236739,
      },
      {
        value: 'liothyronine 50 mcg tablet',
        hasDosage: true,
        questionId: 246932,
      },
      {
        value: 'LevoxyL',
        hasDosage: false,
        questionId: 300534,
      },
      {
        value: 'LevoxyL 100 mcg tablet',
        hasDosage: true,
        questionId: 231895,
      },
      {
        value: 'LevoxyL 112 mcg tablet',
        hasDosage: true,
        questionId: 252514,
      },
      {
        value: 'LevoxyL 125 mcg tablet',
        hasDosage: true,
        questionId: 227013,
      },
      {
        value: 'LevoxyL 137 mcg tablet',
        hasDosage: true,
        questionId: 257592,
      },
      {
        value: 'LevoxyL 150 mcg tablet',
        hasDosage: true,
        questionId: 225651,
      },
      {
        value: 'LevoxyL 175 mcg tablet',
        hasDosage: true,
        questionId: 233107,
      },
      {
        value: 'LevoxyL 200 mcg tablet',
        hasDosage: true,
        questionId: 229394,
      },
      {
        value: 'LevoxyL 25 mcg tablet',
        hasDosage: true,
        questionId: 239555,
      },
      {
        value: 'LevoxyL 50 mcg tablet',
        hasDosage: true,
        questionId: 250009,
      },
      {
        value: 'LevoxyL 75 mcg tablet',
        hasDosage: true,
        questionId: 233953,
      },
      {
        value: 'LevoxyL 88 mcg tablet',
        hasDosage: true,
        questionId: 226499,
      },
      {
        value: 'Levo-T',
        hasDosage: false,
        questionId: 307279,
      },
      {
        value: 'Levo-T 100 mcg tablet',
        hasDosage: true,
        questionId: 382302,
      },
      {
        value: 'Levo-T 112 mcg tablet',
        hasDosage: true,
        questionId: 382282,
      },
      {
        value: 'Levo-T 125 mcg tablet',
        hasDosage: true,
        questionId: 249338,
      },
      {
        value: 'Levo-T 137 mcg tablet',
        hasDosage: true,
        questionId: 382291,
      },
      {
        value: 'Levo-T 150 mcg tablet',
        hasDosage: true,
        questionId: 382281,
      },
      {
        value: 'Levo-T 175 mcg tablet',
        hasDosage: true,
        questionId: 382295,
      },
      {
        value: 'Levo-T 200 mcg tablet',
        hasDosage: true,
        questionId: 382307,
      },
      {
        value: 'Levo-T 25 mcg tablet',
        hasDosage: true,
        questionId: 382300,
      },
      {
        value: 'Levo-T 300 mcg tablet',
        hasDosage: true,
        questionId: 382289,
      },
      {
        value: 'Levo-T 50 mcg tablet',
        hasDosage: true,
        questionId: 382292,
      },
      {
        value: 'Levo-T 75 mcg tablet',
        hasDosage: true,
        questionId: 382290,
      },
      {
        value: 'Levo-T 88 mcg tablet',
        hasDosage: true,
        questionId: 382303,
      },
      {
        value: 'Euthyrox',
        hasDosage: false,
        questionId: 299187,
      },
      {
        value: 'Euthyrox 100 mcg tablet',
        hasDosage: true,
        questionId: 237400,
      },
      {
        value: 'Euthyrox 112 mcg tablet',
        hasDosage: true,
        questionId: 241991,
      },
      {
        value: 'Euthyrox 125 mcg tablet',
        hasDosage: true,
        questionId: 241213,
      },
      {
        value: 'Euthyrox 137 mcg tablet',
        hasDosage: true,
        questionId: 389367,
      },
      {
        value: 'Euthyrox 150 mcg tablet',
        hasDosage: true,
        questionId: 243351,
      },
      {
        value: 'Euthyrox 175 mcg tablet',
        hasDosage: true,
        questionId: 225746,
      },
      {
        value: 'Euthyrox 200 mcg tablet',
        hasDosage: true,
        questionId: 226297,
      },
      {
        value: 'Euthyrox 25 mcg tablet',
        hasDosage: true,
        questionId: 239811,
      },
      {
        value: 'Euthyrox 50 mcg tablet',
        hasDosage: true,
        questionId: 249702,
      },
      {
        value: 'Euthyrox 75 mcg tablet',
        hasDosage: true,
        questionId: 242062,
      },
      {
        value: 'Euthyrox 88 mcg tablet',
        hasDosage: true,
        questionId: 244029,
      },
      {
        value: 'Synthroid',
        hasDosage: false,
        questionId: 301371,
      },
      {
        value: 'Synthroid 100 mcg tablet',
        hasDosage: true,
        questionId: 231970,
      },
      {
        value: 'Synthroid 112 mcg tablet',
        hasDosage: true,
        questionId: 251383,
      },
      {
        value: 'Synthroid 125 mcg tablet',
        hasDosage: true,
        questionId: 231796,
      },
      {
        value: 'Synthroid 137 mcg tablet',
        hasDosage: true,
        questionId: 276415,
      },
      {
        value: 'Synthroid 150 mcg tablet',
        hasDosage: true,
        questionId: 230662,
      },
      {
        value: 'Synthroid 175 mcg tablet',
        hasDosage: true,
        questionId: 238520,
      },
      {
        value: 'Synthroid 200 mcg tablet',
        hasDosage: true,
        questionId: 230352,
      },
      {
        value: 'Synthroid 25 mcg tablet',
        hasDosage: true,
        questionId: 242725,
      },
      {
        value: 'Synthroid 300 mcg tablet',
        hasDosage: true,
        questionId: 248100,
      },
      {
        value: 'Synthroid 50 mcg tablet',
        hasDosage: true,
        questionId: 248284,
      },
      {
        value: 'Synthroid 75 mcg tablet',
        hasDosage: true,
        questionId: 247491,
      },
      {
        value: 'Synthroid 88 mcg tablet',
        hasDosage: true,
        questionId: 245881,
      },
      {
        value: 'Tirosint',
        hasDosage: false,
        questionId: 355544,
      },
      {
        value: 'Tirosint 100 mcg capsule',
        hasDosage: true,
        questionId: 355490,
      },
      {
        value: 'Tirosint 112 mcg capsule',
        hasDosage: true,
        questionId: 355501,
      },
      {
        value: 'Tirosint 125 mcg capsule',
        hasDosage: true,
        questionId: 355484,
      },
      {
        value: 'Tirosint 13 mcg capsule',
        hasDosage: true,
        questionId: 355475,
      },
      {
        value: 'Tirosint 137 mcg capsule',
        hasDosage: true,
        questionId: 355509,
      },
      {
        value: 'Tirosint 150 mcg capsule',
        hasDosage: true,
        questionId: 355503,
      },
      {
        value: 'Tirosint 175 mcg capsule',
        hasDosage: true,
        questionId: 389564,
      },
      {
        value: 'Tirosint 200 mcg capsule',
        hasDosage: true,
        questionId: 389561,
      },
      {
        value: 'Tirosint 25 mcg capsule',
        hasDosage: true,
        questionId: 355470,
      },
      {
        value: 'Tirosint-SoL 100 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389905,
      },
      {
        value: 'Tirosint-SoL 112 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389897,
      },
      {
        value: 'Tirosint-SoL 125 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389921,
      },
      {
        value: 'Tirosint-SoL 200 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389916,
      },
      {
        value: 'Tirosint-SoL 25 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389911,
      },
      {
        value: 'Tirosint 37.5 mcg capsule',
        hasDosage: true,
        questionId: 402011,
      },
      {
        value: 'Tirosint-SoL 37.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397162,
      },
      {
        value: 'Tirosint 44 mcg capsule',
        hasDosage: true,
        questionId: 402019,
      },
      {
        value: 'Tirosint-SoL 44 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397164,
      },
      {
        value: 'Tirosint 50 mcg capsule',
        hasDosage: true,
        questionId: 355467,
      },
      {
        value: 'Tirosint 62.5 mcg capsule',
        hasDosage: true,
        questionId: 402015,
      },
      {
        value: 'Tirosint-SoL 50 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389922,
      },
      {
        value: 'Tirosint-SoL 62.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397169,
      },
      {
        value: 'Tirosint 75 mcg capsule',
        hasDosage: true,
        questionId: 355469,
      },
      {
        value: 'Tirosint-SoL 75 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389900,
      },
      {
        value: 'Tirosint 88 mcg capsule',
        hasDosage: true,
        questionId: 355496,
      },
      {
        value: 'Tirosint-SoL 88 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389910,
      },
      {
        value: 'Tirosint-SoL 13 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389902,
      },
      {
        value: 'Tirosint-SoL 137 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389899,
      },
      {
        value: 'Tirosint-SoL 150 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389901,
      },
      {
        value: 'Tirosint-SoL 175 mcg/mL oral solution',
        hasDosage: true,
        questionId: 389903,
      },
      {
        value: 'Tirosint-SoL',
        hasDosage: true,
        questionId: 389925,
      },
      {
        value: 'levothyroxine',
        hasDosage: false,
        questionId: 296025,
      },
      {
        value: 'levothyroxine (bulk)',
        hasDosage: true,
        questionId: 347088,
      },
      {
        value: 'levothyroxine (bulk) 1 mg/gram powder',
        hasDosage: true,
        questionId: 362431,
      },
      {
        value: 'levothyroxine (bulk) 100 % powder',
        hasDosage: true,
        questionId: 237253,
      },
      {
        value: 'levothyroxine 100 mcg capsule',
        hasDosage: true,
        questionId: 355507,
      },
      {
        value: 'levothyroxine 100 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 362885,
      },
      {
        value: 'levothyroxine 100 mcg tablet',
        hasDosage: true,
        questionId: 239330,
      },
      {
        value: 'levothyroxine 100 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390404,
      },
      {
        value: 'levothyroxine 100 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383551,
      },
      {
        value: 'levothyroxine 112 mcg capsule',
        hasDosage: true,
        questionId: 355495,
      },
      {
        value: 'levothyroxine 112 mcg tablet',
        hasDosage: true,
        questionId: 257160,
      },
      {
        value: 'levothyroxine 112 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383553,
      },
      {
        value: 'levothyroxine 125 mcg capsule',
        hasDosage: true,
        questionId: 355488,
      },
      {
        value: 'levothyroxine 125 mcg tablet',
        hasDosage: true,
        questionId: 244788,
      },
      {
        value: 'levothyroxine 20 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390400,
      },
      {
        value: 'levothyroxine 20 mcg/mL oral solution',
        hasDosage: true,
        questionId: 395094,
      },
      {
        value: 'levothyroxine 200 mcg capsule',
        hasDosage: true,
        questionId: 389574,
      },
      {
        value: 'levothyroxine 200 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 241562,
      },
      {
        value: 'levothyroxine 200 mcg tablet',
        hasDosage: true,
        questionId: 250544,
      },
      {
        value: 'levothyroxine 200 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383570,
      },
      {
        value: 'levothyroxine 25 mcg capsule',
        hasDosage: true,
        questionId: 355476,
      },
      {
        value: 'levothyroxine 25 mcg tablet',
        hasDosage: true,
        questionId: 237942,
      },
      {
        value: 'levothyroxine 25 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383568,
      },
      {
        value: 'levothyroxine 30 mcg/mL oral solution',
        hasDosage: true,
        questionId: 399165,
      },
      {
        value: 'levothyroxine 300 mcg tablet',
        hasDosage: true,
        questionId: 230002,
      },
      {
        value: 'levothyroxine 37.5 mcg capsule',
        hasDosage: true,
        questionId: 402032,
      },
      {
        value: 'levothyroxine 37.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397165,
      },
      {
        value: 'levothyroxine 40 mcg/mL intravenous solution',
        hasDosage: true,
        questionId: 390397,
      },
      {
        value: 'levothyroxine 44 mcg capsule',
        hasDosage: true,
        questionId: 402023,
      },
      {
        value: 'levothyroxine 44 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397173,
      },
      {
        value: 'levothyroxine 50 mcg capsule',
        hasDosage: true,
        questionId: 355493,
      },
      {
        value: 'levothyroxine 50 mcg tablet',
        hasDosage: true,
        questionId: 243806,
      },
      {
        value: 'levothyroxine 50 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383550,
      },
      {
        value: 'levothyroxine 500 mcg intravenous powder for solution',
        hasDosage: true,
        questionId: 242200,
      },
      {
        value: 'levothyroxine 62.5 mcg capsule',
        hasDosage: true,
        questionId: 402012,
      },
      {
        value: 'levothyroxine 62.5 mcg/mL oral solution',
        hasDosage: true,
        questionId: 397154,
      },
      {
        value: 'levothyroxine 75 mcg capsule',
        hasDosage: true,
        questionId: 355468,
      },
      {
        value: 'levothyroxine 75 mcg tablet',
        hasDosage: true,
        questionId: 238501,
      },
      {
        value: 'levothyroxine 75 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383563,
      },
      {
        value: 'levothyroxine 88 mcg capsule',
        hasDosage: true,
        questionId: 355486,
      },
      {
        value: 'levothyroxine 88 mcg tablet',
        hasDosage: true,
        questionId: 240026,
      },
      {
        value: 'levothyroxine 88 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383579,
      },
      {
        value: 'levothyroxine 125 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383582,
      },
      {
        value: 'levothyroxine 13 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383573,
      },
      {
        value: 'levothyroxine 137 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383565,
      },
      {
        value: 'levothyroxine 150 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383558,
      },
      {
        value: 'levothyroxine 175 mcg/mL oral solution',
        hasDosage: true,
        questionId: 383561,
      },
      {
        value: 'levothyroxine 137 mcg tablet',
        hasDosage: true,
        questionId: 226061,
      },
      {
        value: 'levothyroxine 150 mcg tablet',
        hasDosage: true,
        questionId: 246273,
      },
      {
        value: 'levothyroxine 175 mcg tablet',
        hasDosage: true,
        questionId: 225902,
      },
      {
        value: 'CytomeL',
        hasDosage: false,
        questionId: 301999,
      },
      {
        value: 'CytomeL 25 mcg tablet',
        hasDosage: true,
        questionId: 250263,
      },
      {
        value: 'CytomeL 5 mcg tablet',
        hasDosage: true,
        questionId: 237429,
      },
      {
        value: 'CytomeL 50 mcg tablet',
        hasDosage: true,
        questionId: 236623,
      },
      {
        value: 'Armour Thyroid',
        hasDosage: false,
        questionId: 298245,
      },
      {
        value: 'Armour Thyroid 120 mg tablet',
        hasDosage: true,
        questionId: 233637,
      },
      {
        value: 'Armour Thyroid 15 mg tablet',
        hasDosage: true,
        questionId: 239332,
      },
      {
        value: 'Armour Thyroid 180 mg tablet',
        hasDosage: true,
        questionId: 229937,
      },
      {
        value: 'Armour Thyroid 240 mg tablet',
        hasDosage: true,
        questionId: 250548,
      },
      {
        value: 'Armour Thyroid 30 mg tablet',
        hasDosage: true,
        questionId: 251437,
      },
      {
        value: 'Armour Thyroid 300 mg tablet',
        hasDosage: true,
        questionId: 255429,
      },
      {
        value: 'Armour Thyroid 60 mg tablet',
        hasDosage: true,
        questionId: 224882,
      },
      {
        value: 'Armour Thyroid 90 mg tablet',
        hasDosage: true,
        questionId: 226943,
      },
      {
        questionId: '299900',
        value: 'Westhroid',
      },
      {
        questionId: '303622',
        value: 'Triostat',
      },
      {
        questionId: '308071',
        value: 'Thyrolar-1',
      },
      {
        questionId: '307953',
        value: 'Thyrolar-2',
      },
      {
        questionId: '303601',
        value: 'Thyrolar-3',
      },
      {
        questionId: '301146',
        value: 'Liotrix',
      },
      {
        questionId: '371624',
        value: 'WP Thyroid',
      },
      {
        questionId: '311558',
        value: 'Nature-Throid',
      },
      {
        value: 'NP Thyroid',
        questionId: '357795',
      },
      {
        value: 'NP Thyroid 120 mg tablet',
        questionId: '384698',
      },
      {
        value: 'NP Thyroid 15 mg tablet',
        questionId: '382981',
      },
      {
        value: 'NP Thyroid 30 mg tablet',
        questionId: '357746',
      },
      {
        value: 'NP Thyroid 60 mg tablet',
        questionId: '357763',
      },
      {
        value: 'NP Thyroid 90 mg tablet',
        questionId: '357753',
      },
    ],
  },
  {
    id: 'medications',
    type: 'medicationList',
    endpoint: 'medications',
    // skip: 'supplements',
    skip: 'glp1-history',
    useUsaRx: true,
    title: 'Other Medications and Supplements',
    prompt: 'Please add the other medications and supplements you are currently taking',
    other: { questionId: '301410' },
    prefix: 'Medications currently taking -',
    extend: true,
    isInputOnly: true,
    options: [],
    nothingText: "I don't take other medications",
  },

  {
    id: 'glp1-history',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: 'Are you currently or have you ever taken a GLP-1 medication?',
    options: [
      { questionId: 'ans', answer: 'I am currently taking a glp-1 medication', display: 'I am currently taking a glp-1 medication', value: 'Yes', nextQuestion: 'current-glp1-medications' },
      {
        questionId: 'ans',
        answer: 'I have taken a GlP-1 medication but I’m not currently',
        display: 'I have taken a GlP-1 medication but I’m not currently',
        value: 'Yes',
        nextQuestion: 'stopped-glp1-medications',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'N',
        display: 'I have never taken a GLP-1 medication',
        value: 'I have never taken a GLP-1 medication',
        nextQuestion: 'allergies',
      },
    ],
  },

  {
    id: 'stopped-glp1-medications',
    type: 'multiple',
    endpoint: 'medicalHistory',
    prompt: 'Which GLP-1 medication(s) have you taken previously? ',
    nextQuestion: 'allergies',
    options: [
      {
        value: 'Liraglutide (Victoza, Saxenda)',
        display: 'Liraglutide (Victoza, Saxenda)',
        answer: 'Y',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
      },
      {
        value: 'Tirzepatide (Mounjaro, Zepbound, or compounded)',
        display: 'Tirzepatide (Mounjaro, Zepbound, or compounded)',
        questionId: 'ans',
      },
      {
        value: 'Semaglutide (Ozempic, Wegovy, or compounded)',
        display: 'Semaglutide (Ozempic, Wegovy, or compounded)',
        questionId: 'ans',
      },
      {
        value: 'Other GLP-1 medication',
        questionId: '5',
        nextQuestion: 'other-stopped-glp1-medications',
      },
    ],
  },

  {
    id: 'other-stopped-glp1-medications',
    type: 'input',
    endpoint: 'medicalHistory',
    prompt: 'What other GLP-1 medication have you taken previously?',
    prefix: 'Stopped GLP-1: ',
    answer: 'Y',
    nextQuestion: 'allergies',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        placeholder: 'tell us more',
      },
    ],
  },

  {
    id: 'current-glp1-medications',
    type: 'single',
    endpoint: 'medicalHistory',
    prompt: 'Which GLP-1 medication(s) are you currently taking? ',
    nextQuestion: 'agree-to-stop',
    options: [
      {
        value: 'Current GLP-1: Liraglutide (Victoza, Saxenda)',
        display: 'Liraglutide (Victoza, Saxenda)',
        answer: 'Y',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        nextQuestion: 'agree-to-stop',
      },
      {
        value: 'Tirzepatide (Mounjaro, Zepbound, or compounded)',
        questionId: 'ans',
        nextQuestion: 'tirzepatide-dose',
      },
      {
        value: 'Semaglutide (Ozempic, Wegovy, or compounded)',
        nextQuestion: 'semaglutide-dose',
        questionId: 'ans',
      },
      {
        value: 'Other GLP-1 medication',
        questionId: '5',
        nextQuestion: 'other-current-glp1-medications',
      },
    ],
  },

  {
    id: 'other-current-glp1-medications',
    type: 'input',
    endpoint: 'medicalHistory',
    prompt: 'What other GLP-1 medication have you taken previously?',
    prefix: 'Currently takinkg GLP-1: ',
    answer: 'Y',
    nextQuestion: 'agree-to-stop',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        placeholder: 'tell us more',
      },
    ],
  },
  {
    id: 'tirzepatide-dose',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prefix: 'Currently takinkg GLP-1: ',
    prompt: `What dose of tirzepatide (Mounjaro, Zepbound, or compounded) are you taking?`,
    description: 'Tell us your current dose in milligrams (mg) per week',
    nextQuestion: 'agree-to-stop',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '2.5 mg',
        value: 'Tirzepatide 2.5 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '5 mg',
        value: 'Tirzepatide 5 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '7.5 mg',
        value: 'Tirzepatide 7.5 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '10 mg',
        value: 'Tirzepatide 10 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '12.5 mg',
        value: 'Tirzepatide 12.5 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '15 mg',
        value: 'Tirzepatide 15 mg',
        nextQuestion: 'agree-to-stop',
      },
    ],
  },
  {
    id: 'semaglutide-dose',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prefix: 'Currently takinkg GLP-1: ',
    prompt: `What dose of Semaglutide (Ozempic, Wegovy, or compounded) are you taking?`,
    description: 'Tell us your current dose in milligrams (mg) per week',
    nextQuestion: 'agree-to-stop',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '0.25 mg',
        value: 'Semaglutide 0.25 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '0.5 mg',
        value: 'Semaglutide 0.5 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '1 mg',
        value: 'Semaglutide 1 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '1.25 mg',
        value: 'Semaglutide 1.25 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '1.7 mg',
        value: 'Semaglutide 1.7 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '2 mg',
        value: 'Semaglutide 2 mg',
        nextQuestion: 'agree-to-stop',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '502' : '521',
        answer: 'Y',
        display: '2.4 mg',
        value: 'Semaglutide 2.4 mg',
        nextQuestion: 'agree-to-stop',
      },
    ],
  },

  {
    id: 'agree-to-stop',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: `If you're prescribed a GLP-1 medication through Paloma Health, do you agree to stop taking your current GLP-1 medication?`,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '522' : '541',
        answer: 'Y',
        display: 'Yes, I agree to stop taking my current GLP-1 medication & will inform my doctor who prescribed me this before doing so',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '522' : '541',
        answer: 'N',
        display: 'No, I prefer to continue my current GLP-1 medication outside of the Paloma Health platform',
      },
    ],
  },
  {
    id: 'enough-glp1',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    prompt: `Do you have enough medication to maintain your current dosage for the next 1-2 weeks?`,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '523' : '542',
        display: 'Yes, I do',
        answer: 'Y',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '523' : '542',
        display: `No, I don't`,
        answer: 'N',
      },
    ],
  },
  {
    id: 'happy-current-glp1',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: false,
    skip: 'why-decrease-glp1-medications',
    prompt: `Are you happy with your current GLP-1 dose?`,
    nextQuestion: 'allergies',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        answer: 'Y',
        display: 'Yes but I would like to increase my dose if it is okay with me',
        value: 'Yes but I would like to increase my dose if it is okay with me',
        nextQuestion: 'allergies',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        answer: 'Y',
        display: 'Yes I want to keep my current dose',
        value: 'Yes I want to keep my current dose',
        nextQuestion: 'allergies',
      },
      { questionId: 'ans', answer: `No I want to decrease my current dose`, display: 'No I want to decrease my current dose', value: 'N', nextQuestion: 'why-decrease-glp1-medications' },
    ],
  },

  {
    id: 'why-decrease-glp1-medications',
    type: 'input',
    endpoint: 'medicalHistory',
    prompt: 'Please tell us why you would like to decrease your GLP-1 dose.',
    prefix: 'No I want to decrease my current dose: ',
    answer: 'N',
    nextQuestion: 'allergies',
    extend: true,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '524' : '543',
        placeholder: 'tell us more',
      },
    ],
  },

  {
    id: 'allergies',
    type: 'allergies',
    endpoint: 'allergies',
    prompt: 'Do you have any allergies to medications or other substances?',
    options: [
      {
        questionId: '12990',
        prefix: 'Allergies to medications / other substances -',
        answer: 'Y',
        value: 'Yes',
        placeholder: 'Explain',
      },
      {
        questionId: '12990',
        answer: 'NKDA',
        value: 'No',
      },
    ],
  },

  {
    id: 'opiate',
    type: 'single',
    endpoint: 'medicalHistory',
    // onlyFirstTime: true,
    prompt: `Are you currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs?`,
    extend: true,
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '542' : '561',
        prefix: '',
        answer: 'Y',
        value: 'Yes',
        placeholder: 'include date range, name, dose, and frequency',
      },
      { questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '542' : '561', answer: 'N', value: 'No' },
    ],
  },

  {
    id: 'willing',
    type: 'multiple',
    endpoint: 'socialHistory',
    prompt: 'Are you willing to',
    skip: 'concerns',
    options: [
      {
        value: 'Increase your physical activity alongside medication if clinically appropriate',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.205' : 'LOCAL.583',
        answer: 'Y',
      },
      {
        value: 'Reduce your caloric intake alongside medication if clinically appropriate',
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? 'LOCAL.206' : 'LOCAL.584',
        answer: 'Y',
      },
    ],
  },
  {
    id: 'concerns',
    type: 'input',
    endpoint: 'problems',
    skip: 'familyConditions',
    // onlyFirstTime: true,
    prompt: 'Do you have any further information which you would like your provider to know?',
    description: `Please do not include urgent or emergent medical information here, as this is not reviewed immediately.`,
    defaults: { '185087000': '' },
    prefix: 'Other medical concerns / details -',
    extend: true,
    options: [{ questionId: '185087000', placeholder: 'Add them here...' }],
  },
  {
    id: 'familyConditions',
    type: 'input',
    endpoint: 'familyHistory',
    skip: 'great',
    onlyFirstTime: true,
    prompt: 'Please indicate any major conditions/illnesses that your immediate family members have',
    defaults: { '8': '' },
    prefix: 'Major conditions / illnesses -',
    options: [
      {
        questionId: '8',
        placeholder: 'Indicate any major conditions/illnesses',
      },
    ],
  },
  {
    id: 'great',
    section: 'vitals',
    type: 'information',
    title: `You're almost done!`,
    status: 'vitals',
    skip: 'pharmacy',
    onlyFirstTime: false,
    text: ['We have a few more questions about your symptoms and lifestyle. Please take a moment to fill out the following questions, they will help us deliver the best care.'],
  },
  {
    id: 'general',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'General Information',
    onlyFirstTime: false,
    defaults: { EMPLOYMENT: '', LOCAL_110: '' },
    options: [
      { questionId: 'EMPLOYMENT', type: 'text', placeholder: 'Profession' },
      {
        questionId: 'LOCAL_110',
        type: 'text',
        placeholder: 'Highest Education Level',
      },
    ],
  },
  {
    id: 'smoke',
    section: 'vitals',
    type: 'smokePick',
    endpoint: 'socialHistory',
    title: 'How many cigarettes do you smoke per day?',
    onlyFirstTime: false,
    questionId: 'LOCAL.92',
    options: [
      {
        isDefault: true,
        answer: '0',
        value: '0',
      },
      {
        answer: '1 to 5',
        value: '1-5',
      },
      {
        answer: '6 to 10',
        value: '6-10',
      },
      {
        answer: '11 to 20',
        value: '11-20',
      },
      {
        answer: 'more than 20',
        value: '20+',
      },
    ],
  },
  {
    id: 'alcohol',
    section: 'vitals',
    type: 'alcoholPick',
    endpoint: 'socialHistory',
    prompt: 'How much alcohol do you drink in a week ?',
    onlyFirstTime: false,
    questionId: 'LOCAL.94',
    options: [],
  },
  {
    id: 'drugs',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'What kind of recreational drug have you used in the past year?',
    onlyFirstTime: false,
    defaults: { LOCAL_97: '' },
    extend: true,
    skip: 'caffeine',
    options: [
      {
        questionId: 'LOCAL_97',
        prefix: 'Recreational drugs used -',
        type: 'text',
        placeholder: 'What drugs do you use?',
      },
    ],
  },
  {
    id: 'caffeine',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'How many caffeinated beverages or cups of coffee do you drink per day?',
    onlyFirstTime: false,
    defaults: { CAFFEINEPERDAY: '' },
    extend: false,
    options: [
      {
        questionId: 'CAFFEINEPERDAY',
        prefix: 'Cups per day - ',
        type: 'text',
        placeholder: 'Cups a day',
        inputmode: 'decimal',
      },
    ],
  },
  {
    id: 'cardio',
    section: 'vitals',
    type: 'smokePick',
    endpoint: 'socialHistory',
    title: 'How many days a week do you engage in moderate physical activities?',
    prompt: '(makes you slightly breathless)',
    onlyFirstTime: false,
    questionId: 'LOCAL.98',
    options: [
      {
        isDefault: true,
        answer: '0',
        value: '0',
      },
      {
        answer: '1',
        value: '1',
      },
      {
        answer: '2',
        value: '2',
      },
      {
        answer: '3',
        value: '3',
      },
      {
        answer: '4',
        value: '4',
      },
      {
        answer: '5',
        value: '5',
      },
      {
        answer: '6',
        value: '6',
      },
      {
        answer: '7',
        value: '7',
      },
    ],
  },
  {
    id: 'exerciseType',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'What kind of exercises do you engage in?',
    onlyFirstTime: false,
    defaults: { LOCAL_99: '' },
    extend: true,
    skip: 'sleepMeds',
    options: [{ questionId: 'LOCAL_99', type: 'text', placeholder: 'Input exercises' }],
  },
  {
    id: 'sleepMeds',
    section: 'vitals',
    type: 'single',
    endpoint: 'socialHistory',
    prompt: 'Do you take medication/supplements to fall asleep?',
    onlyFirstTime: false,
    options: [
      {
        questionId: 'LOCAL.106',
        prefix: 'Medications for sleep -',
        answer: 'Y',
        value: 'Yes',
        placeholder: 'What do you take?',
      },
      { questionId: 'LOCAL.106', answer: 'N', value: 'No' },
    ],
  },
  {
    id: 'quality',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    onlyFirstTime: false,
    prompt: 'How would you rate the overall quality of your sleep? (Out of 10, 1 being bad and 10 being great)',
    defaults: { LOCAL_108: '' },
    options: [{ questionId: 'LOCAL_108', type: 'text', placeholder: 'Overall quality', inputmode: 'decimal' }],
  },
  {
    id: 'hours',
    section: 'vitals',
    type: 'input',
    endpoint: 'socialHistory',
    prompt: 'How many hours of sleep do you get at night?',
    onlyFirstTime: false,
    defaults: { LOCAL_109: '' },
    options: [{ questionId: 'LOCAL_109', placeholder: 'Hours of sleep', inputmode: 'decimal' }],
  },
  {
    id: 'pharmacy',
    section: 'vitals',
    type: 'pharmacy',
    endpoint: 'pharmacy',
    onlyFirstTime: false,
  },
  {
    id: 'labCenter',
    section: 'vitals',
    type: 'labCenter',
    endpoint: 'labCenter',
    onlyFirstTime: false,
  },
  {
    id: 'finished',
    type: 'information',
    title: 'You Are All Set',
    onlyFirstTime: false,
    text: ['Your appointment is scheduled an you will receive an email with instructions on how to complete your online visit.'],
    buttonText: 'My Dashboard',
    status: 'completed',
    link: '/',
  },
  {
    id: 'disqualified',
    type: 'disqualified',
    status: 'disqualified',
    onlyFirstTime: false,
    link: '/',
  },

  // {
  //   id: 'thanks',
  //   type: 'information',
  //   title: 'Thank You',
  //   skip: 'great',
  //   status: 'symptoms',
  //   text: [
  //     'You are almost done!',
  //     'We do have questions for you about your symptoms and your lifestyle. Please take the time to fill out the next questions. Your answers help us to better serve you!',
  //   ],
  // },
  // ...intakeCommonTrunks,
];
